<template>
  <section class="g-pb-100--lg g-pb-30">
    <div class="container">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'unify-page-content',
}
</script>
